import React from "react";
import { Box, Flex, Text, Select, Spinner } from "@chakra-ui/react";
import Table from "../shared/Table";
import {
  backgroundLight,
  newBorder,
  primary,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";

const CardList = ({
  slug,
  data,
  loading,
  sortField,
  sortOrder,
  onSortChange,
  page,
  pages,
  pageSize,
  pageSizes,
  setPage,
  setPageSize,
  totalCount,
  navigate,
  title,
  noItemsText,
  renderItem, // 🆕 render function
  selectOptions,
  isOnlySort,
  p,
}) => {
  // const { t } = useTranslation();

  return (
    <Box w="100%" p={p ? p : "1.25rem 0rem 0"} bg={backgroundLight}>
      {/* {loading ? (
        <Flex justify="center" align="center" minH="300px">
          <Spinner size="lg" />
        </Flex>
      ) : data?.length > 0 ? ( */}
      <>
        {!isOnlySort && (
          <Flex
            align="center"
            justify="space-between"
            p={isOnlySort ? "0rem 0rem 1rem" : "0rem 1.5rem 1rem"}
          >
            <Flex align="center">
              <Text
                fontSize="md"
                fontWeight="600"
                color={textPrimary}
                mr="0.5rem"
              >
                {title}
              </Text>
            </Flex>

            <Flex align="center" justify="flex-end">
              {
                <Select
                  maxW="200px"
                  bg={white}
                  borderRadius="1rem"
                  border={`0px solid ${newBorder}`}
                  color={textSecondary}
                  size="md"
                  fontSize="sm"
                  fontWeight="500"
                  value={`${sortField}-${sortOrder}`}
                  onChange={(e) => {
                    const [field, order] = e.target.value.split("-");
                    onSortChange(field, order);
                  }}
                  _focus={{
                    borderColor: primary,
                    boxShadow: "none",
                  }}
                >
                  {selectOptions}
                </Select>
              }
            </Flex>
          </Flex>
        )}

        {/* Card Items */}

        <Flex
          direction="column"
          gap="2rem"
          p={isOnlySort ? "0.5rem 0rem 0" : "0rem 1.5rem"}
        >
          {data.map((item) => renderItem(item))}
        </Flex>

        {/* Pagination */}

        <Flex p="1.5rem 0">
          <Table.Pagination
            p="0 1.5rem 1rem"
            loading={loading}
            page={page}
            pages={pages}
            pageSize={pageSize}
            pageSizes={pageSizes}
            navigate={navigate}
            setPage={setPage}
            setPageSize={setPageSize}
            totalCount={totalCount}
          />
        </Flex>
      </>
      {/* ) : (
        <Text color={textSecondary}>{noItemsText}</Text>
      )} */}
    </Box>
  );
};

export default CardList;
